import { PlayerWithTeam } from '@/feature/betslip-pickem/types';
import { ProjectionType } from '@/types/api.generated';

export const GAP_WIDTH = 8;
export const POPULAR_PLAYERS_FILTER = 'popular_players';

export type Section = {
    title: string;
    data: PlayerWithTeam[];
    projectionType: ProjectionType;
};

export const calculateTileButtonWidth = (
    hasCurrentOutcome: boolean,
    hasOtherOutcome: boolean,
    halfWidthPercent: number,
    shouldShowSwapForCurrent?: boolean,
    shouldShowSwapForOther?: boolean,
    containerWidth?: number
) => {
    let smallWidthPercent = 30;
    let bigWidthPercent = 70;
    if (containerWidth) {
        const containerWithoutGap = containerWidth - GAP_WIDTH;
        smallWidthPercent = ((containerWithoutGap / 3) * 100) / containerWidth;
        bigWidthPercent = (((containerWithoutGap * 2) / 3) * 100) / containerWidth;
    }

    if (!hasCurrentOutcome) {
        return shouldShowSwapForCurrent ? smallWidthPercent : 0;
    }
    if (hasOtherOutcome) {
        return halfWidthPercent;
    }
    return shouldShowSwapForOther ? bigWidthPercent : 100;
};
